import {
  CabysCatalog,
  LatestCabysCodes,
  EconomicActivity,
  Setting,
} from '../../../types/settings/Setting';
import { UserAuth } from '../../../types/users/User';

export const GET_CABYS_CATALOG = 'GET_CABYS_CATALOG';
export const LATSEST_CABYS_CODES = 'LATSEST_CABYS_CODES';
export const GET_ECONOMIC_ACTIVITY_CATALOG = 'GET_ECONOMIC_ACTIVITY_CATALOG';
export const GET_ECONOMIC_ACTIVITY_RESTAURANT =
  'GET_ECONOMIC_ACTIVITY_RESTAURANT';
export const RESET_SETTINGS_STATE = 'RESET_SETTINGS_STATE';
export const GET_SETTINGS = 'GET_SETTINGS';

interface ActionGetCabysCatalog {
  type: typeof GET_CABYS_CATALOG;
  payload: CabysCatalog[];
}

interface ActionLatestCabysCodes {
  type: typeof LATSEST_CABYS_CODES;
  payload: LatestCabysCodes[];
}

interface ActionGetEconomicActivityCatalog {
  type: typeof GET_ECONOMIC_ACTIVITY_CATALOG;
  payload: EconomicActivity[];
}

interface ActionGetEconomicActivityRestaurant {
  type: typeof GET_ECONOMIC_ACTIVITY_RESTAURANT;
  payload: EconomicActivity[];
}

export interface ActionResetSettingsState {
  type: typeof RESET_SETTINGS_STATE;
}

export interface ActionGetSettings {
  type: typeof GET_SETTINGS;
  payload: Setting;
}

export type TypesActionsSettings =
  | ActionGetCabysCatalog
  | ActionLatestCabysCodes
  | ActionGetEconomicActivityCatalog
  | ActionGetEconomicActivityRestaurant
  | ActionResetSettingsState
  | ActionGetSettings;

export interface GetCabysCatalogArgs {
  callbackPre?: Function;
  callbackSuccess?: Function;
  callbackError?: Function;
  search?: string;
}

export interface GetEconomicActivityRestaurantgArgs {
  user: UserAuth;
  callbackPre?: Function;
  callbackSuccess?: Function;
  callbackError?: Function;
  search?: string;
}

export interface LatestCabysCodesArgs extends GetCabysCatalogArgs {
  accountId: string;
}

export interface GetSettings
  extends Omit<LatestCabysCodesArgs, 'callbackPre'> {}
